import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-hero-a',
  styleUrl: 'hero-a.css',
  shadow: true,
})
export class HeroA {
  @Prop() titleYellow        : string;
  @Prop() titleWhite         : string;
  @Prop() titleMaxWidth      : string = '800px';
  @Prop() textAlign          : string = 'left';
  @Prop() backgroundImage    : string;
  @Prop() backgroundPosition : string = 'right';
  @Prop() backgroundSize     : string = 'cover';
  @Prop() paddingTop         : string = '0';
  @Prop() height             : string = '640px';

  render() {
    return (
      <Host
        style={{
          alignItems: (this.textAlign == 'left') ? 'flex-start' : (this.textAlign == 'right') ? 'flex-end' : 'center',
          minHeight: this.height,
          backgroundImage: `url(${this.backgroundImage})`,
          backgroundPosition: this.backgroundPosition,
          backgroundSize: this.backgroundSize,
        }}
      >
        <div
          class="title-container"
          style={{
            maxWidth: this.titleMaxWidth,
            paddingTop: this.paddingTop,
            textAlign: this.textAlign,
          }}
        >
          <slot name="sub-title"></slot>
          <slot name="title"></slot>
        </div>
        <slot name="content-container"></slot>
      </Host>
    );
  }

}
